// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export const EntryBlockWrapper = styled.div`
  background: ${(props) => props.theme.colorPalette.gray[300]};
  padding: 16px;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin-top: 24px;

  @media ${(props) => props.theme.mediaQuery.medium} {
    margin-top: 16px;
    margin-left: ${(props) => (!props.fullWidth ? 'calc(350px + 4.054054054054054%)' : '0')};
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    margin-top: 24px;
    margin-left: ${(props) => (!props.fullWidth ? 'calc(384px + 2.2044088176352705%)' : '0')};
    ${(props) =>
      !props.fullWidth && props.isCollectionsZoomEnabled && ' margin-left: calc(384px + 32px);'}
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

export const StyledButton = styled.button`
  width: 200px;
  height: 47px;
  border-radius: 6px;
  background: #162e41;
  color: ${(props) => props.theme.colorPalette.white};
  border: none;
  text-align: center;
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
  overflow: hidden;
`;
